module.exports = __webpack_public_path__ + "static/media/OE.031d737e.pdf";